import { createAPI } from '../../common'
// MediaCloudPaperManageLayoutPlan
export default {
  // 获取全部报纸
  getAllPapers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0hfuBmmQbqfst', 'get', config),
  // 获取叠
  getLayoutFoldlist: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0hfuMbzpvuGpmeMjtu',
      'get',
      config
    ),
  // 获取叠＆栏目
  getPlanLayoutTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0qmboMbzpvuUsff',
      'get',
      config
    ),
  // 调版
  postSwapLayout: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0txbqMbzpvu', 'post', config),
  // 上版
  postOnLayout: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0poMbzpvu', 'post', config),
  // 版面规划导出excel
  exportLayoutPlan: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0fyqpsuMbzpvuQmbo',
      'post',
      config
    ),
  // 查询操作日志
  getPlanLogLists: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0mphMjtut', 'post', config),

  // 获取模板管理列表
  getLpTemplateList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0ufnqmbuf0hfuMqUfnqmbufMjtu',
      'get',
      config
    ),
  // 修改模板
  updateLpTemplate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0ufnqmbuf0vqebufMqUfnqmbuf',
      'post',
      config
    ),
  // 删除模板
  deleteLpTemplate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0ufnqmbuf0efmfufMqUfnqmbuf',
      'DELETE',
      config
    ),
  // 另存为模板
  addLpTemplate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0ufnqmbuf0beeMqUfnqmbuf',
      'POST',
      config
    ),
  // 应用模板列表
  getLpTemplateListForUse: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0ufnqmbuf0hfuMqUfnqmbufMjtuGpsVtf',
      'POST',
      config
    ),
  // 应用模板检查是否包含大样信息的版面
  checkHasComposeLcPlan: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0ufnqmbuf0difdlIbtDpnqptfMdQmbo',
      'get',
      config
    ),
  // 批量应用模板检查是否包含大样信息的版面
  batchCheckHasComposeLcPlan: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0ufnqmbuf0cbudiDifdlIbtDpnqptfMdQmbo',
      'get',
      config
    ),
  // 应用模板点击执行
  useLpTemplate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0ufnqmbuf0vtfMqUfnqmbuf',
      'post',
      config
    ),
  // 批量应用模板点击执行
  batchUseLpTemplate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvu0qmbo0ufnqmbuf0cbudiVtfMqUfnqmbuf',
      'post',
      config
    )
}
